import { isValid, isWithinInterval, parseISO } from "date-fns";

import { AccountingAccount } from "../models/accounting.account.model";
import { Tax } from "../models/tax.model";
import { Unit } from "../models/unit.model";
import { taxPurchaseCodes, taxSaleCodes } from "../libraries/tax.code.library";

export function companyYearList(creation_date?: string): number[] {
  if (!creation_date) return [new Date().getFullYear()]
  let dateString: string = (creation_date.length === 10) ? `${creation_date}T00:00:00.000` : creation_date
  let dateValue: Date = new Date(dateString)
  if (isNaN(dateValue.getTime())) return [new Date().getFullYear()]
  let yearStart: number = dateValue.getFullYear()
  let yearCurrent: number = new Date().getFullYear()
  let list: number[] = []

  for (let year = yearCurrent; year >= yearStart; year--) {
    list.push(year)
  }

  return list
}

export function measureUnitList(type: 'service' | 'product', measure_units: Unit[]): Unit[] {
  return measure_units.filter((item) => (item.type === type))
}

export function accountingAccountCoefficientList(coefficient: 'positive' | 'negative', accounting_accounts: AccountingAccount[]): AccountingAccount[] {
  switch (coefficient) {
    case 'positive':
      return accounting_accounts.filter((item) => (item.coefficient === 1))
    case 'negative':
      return accounting_accounts.filter((item) => (item.coefficient === -1))
    default:
      return []
  }
}

export function taxFeeList(type: string, date: string, subject_tax: boolean, tax_fees: Tax[]): Tax[] {
  let isValidDate: boolean = isValid(parseISO(date))

  switch (type) {
    case 'credit':
      return tax_fees.filter(item => (subject_tax ? item.code !== 'NO_VAT' : item.behavior === 'SALE_ZERO_VAT') && taxSaleCodes().includes(item.code) && item.active && isValidDate && (!item.effectiveFrom || !item.effectiveTo || isWithinInterval(parseISO(date), {start: parseISO(item.effectiveFrom), end: parseISO(item.effectiveTo)}))) || []
    case 'debit':
      return tax_fees.filter(item => (subject_tax ? item.behavior !== '' : item.behavior === 'PURCHASE_NON_DEDUCTIBLE') && taxPurchaseCodes().includes(item.code) && item.active && isValidDate && (!item.effectiveFrom || !item.effectiveTo || isWithinInterval(parseISO(date), {start: parseISO(item.effectiveFrom), end: parseISO(item.effectiveTo)}))) || []
    default:
      return []
  }
}

